import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import Button from '../../baseComponents/gui/button/Button'
import { defaultStore, stores } from '../../../translations'
import { getConfig } from '../../..//utils/getConfig'

const Match3Busters = React.forwardRef(function Match3Busters(
  { isVisible, isAnimate, wrapper: { eventBus } = {}, list, activeItem, setActiveItem, trigger },
  ref,
) {
  const { cdn: cdnBaseUrl } = getConfig()

  const initialState = useMemo(() => {
    return list.reduce((acc, { name, count }) => {
      acc[name] = count
      return acc
    }, {})
  }, [list])

  const [bustersCount, setBustersCount] = useState(initialState)

  useEffect(() => {
    if (!eventBus) return
    eventBus.addEventListener('buster-complete', updateBustersCount)
  }, [eventBus])

  useEffect(() => {
    setBustersCount(initialState)
  }, [trigger])

  function applyBuster(name, label) {
    if (isAnimate || bustersCount[name] === 0) return
    eventBus.dispatchEvent({ type: 'buster-apply', data: { name, count: bustersCount[name] - 1 } })
    setActiveItem(label)
  }

  const updateBustersCount = ({ data: { boosterName } }) => {
    setBustersCount((prevState) => ({
      ...prevState,
      [boosterName]: prevState[boosterName] - 1,
    }))
  }

  const getBusterImageLink = (index) => {
    if (defaultStore === stores.ae) {
      return `${cdnBaseUrl}/images/match3/me/buster-${index}.png`
    }
    return `${cdnBaseUrl}/images/match3/buster-${index}.png`
  }

  return (
    <div
      className={classNames('match3__busters', isVisible && 'match3__busters_visible')}
      ref={ref}
    >
      {items()}
    </div>
  )

  function items() {
    return list.map(({ label, name }, index) => {
      return (
        <div
          key={'match3__buster-item-' + index}
          className={classNames(`match3__buster-item`, {
            'match3__buster-item_active': activeItem === label,
          })}
        >
          <Button
            className={'match3__button'}
            onClick={() => applyBuster(name, label)}
          >
            <img
              src={getBusterImageLink(index)}
              alt={''}
            />
          </Button>
          <div className={'match3__buster-item-value'}>{bustersCount[name]}</div>
        </div>
      )
    })
  }
})
export default Match3Busters
Match3Busters.propTypes = {}
